import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class NullDataHandlerService {

    private readonly pageNotFoundURL = '/pageNotFound';

    constructor(protected router: Router){
    }

    protected redirectToNotFound(){
        this.router.navigateByUrl(this.pageNotFoundURL);
    }

}

